<template>
    <div v-if="topBarShow" class="topBar">
        <img class="topBarItem paddingL" src="https://imagessl.edujia.com/A-1ed71af7_20231122101853.png" @click="closeClick"/>
        <img  class="topBarItem" src="https://imagessl.edujia.com/A-1ed71af7_20231122101821.png" @click="minClick"/>
        <img v-if="isMax" class="topBarItem" src="https://imagessl.edujia.com/A-1ed71af7_20231122101654.png" @click="maxClick"/>
        <img v-else class="topBarItem" src="https://imagessl.edujia.com/A-1ed71af7_20231122101616.png" @click="maxClick"/>
        <img v-if="lock" class="topBarItem" src="https://imagessl.edujia.com/A-1ed71af7_20231122101313.png" @click="btn1click"/>
        <img v-else class="topBarItem" src="https://imagessl.edujia.com/A-1ed71af7_20231122101435.png" @click="btn1click"/>
        <!-- <img v-if="islogin" class="faceIcon" :src="faceIcon" @click="userInfoClick"/>  -->
    </div>
    <div v-else class="topBarWhite"></div>
</template>

<script>
export default {
    name: "menubar",
    data(){
        return {
            isMax:false,
            lock:true,
            topBarShow:false,
            faceIcon:"",
            pageWidth:document.documentElement.clientWidth
        }
    },
    computed:{
        islogin(){
            return this.$store.state.token;
        }
    },
    created(){
        console.log("menubar...");
        if(this.$common.isElectron()){
            const { ipcRenderer } = window.require('electron')
            if(ipcRenderer){
                ipcRenderer.on('clientInfo', (event, args) => {
                  // 处理主进程传递过来的参数
                  console.log('Received command line args:', args);
                  if(this.isVersionLessThan(args.version,'1.0.2')){
                    this.topBarShow=false;
                  }else{
                    this.topBarShow=true;
                  }
                });
                ipcRenderer.on('changeFocus', (event, isLock) => {
                    this.lock=isLock;
                })
            }
        }
        this.faceIcon=localStorage.getItem("edujia:group:web:faceIcon")
    },
    methods:{
        userInfoClick(){
            this.$store.commit("modifyLoginDailogShow",!this.$store.state.loginDailogShow)
        },
        isVersionLessThan(version, targetVersion) {
          // 将版本号拆分成主版本号、次版本号和修订号
          const [currentMajor, currentMinor, currentPatch] = version.split('.').map(Number);
          const [targetMajor, targetMinor, targetPatch] = targetVersion.split('.').map(Number);

          // 比较主版本号、次版本号和修订号
          if (currentMajor < targetMajor) {
            return true;
          } else if (currentMajor === targetMajor) {
            if (currentMinor < targetMinor) {
              return true;
            } else if (currentMinor === targetMinor) {
              return currentPatch < targetPatch;
            }
          }

          return false;
        },
        minClick() {
            const { ipcRenderer } = window.require('electron')
            if(ipcRenderer){
                ipcRenderer.send('minClick');
            }
        },
        maxClick() {
            this.isMax=!this.isMax;
            const { ipcRenderer } = window.require('electron')
            if(ipcRenderer){
                ipcRenderer.send('maxClick');
            }
        },
        closeClick() {
            const { ipcRenderer } = window.require('electron')
            if(ipcRenderer){
                ipcRenderer.send('closeClick');
            }
        },
        btn1click(){
            this.lock=!this.lock;
            const { ipcRenderer } = window.require('electron')
            if(ipcRenderer){
                ipcRenderer.send('changeFocus');
            }
        },
    }
}
</script>

<style scoped>
    .paddingL{
        margin-left: 16px;
    }

    .topBarWhite{
        width: 100%;
        height: 32px;
        background-color: #fff;
        position: absolute;
        left: 0;
        top: 0;
    }

    .topBar{
        width: 100%;
        min-width: 200px;
        height: 32px;
        /*display: flex;
        align-items: center;*/
        -webkit-app-region: drag;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99999;
        background-image: linear-gradient(180deg, #ECECEC 0%, #CDCDCD 100%);
    }

    .topBarItem{
        width: 12px;
        height: 12px;
        border-radius: 20px;
        margin-right: 8px;
        -webkit-app-region: no-drag;
    }

    .faceIcon{
        position: absolute;
        right: 16px;
        top: 4px;
        width: 24px;
        height: 24px;
        border-radius: 24px;
        -webkit-app-region: no-drag;
    }
</style>